import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const RapidElearning = lazy(
  () =>
    import(
      /* webpackChunkName: "TrainingLibraryRapidElearning" */ 'modules/trainingLibrary/RapidElearning/pages/RapidElearning'
    )
)

const RapidElearningRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={routes.root} component={RapidElearning} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default RapidElearningRouting
